import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LOCALIZATION_LOCALE, MONTH_FORMAT } from '../models/enums';
import { DateTimeUtils } from '../utils';

@Pipe({
  name: 'monthFormatter',
  pure: false,
})
export class MonthFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: Date, monthAsTextOnly?: boolean): string {
    if (!value) {
      return '';
    }

    let resultDate = this.getResult(
      value,
      this.translateService.currentLang as LOCALIZATION_LOCALE,
      monthAsTextOnly
    );

    this.translateService.onLangChange.subscribe(() => {
      resultDate = this.getResult(
        value,
        this.translateService.currentLang as LOCALIZATION_LOCALE,
        monthAsTextOnly
      );
    });

    return resultDate;
  }

  private getResult(
    input: Date,
    currentLang: LOCALIZATION_LOCALE,
    monthAsTextOnly?: boolean
  ): string {
    if (monthAsTextOnly) {
      return this.translateService.instant(`pipes.month.${input.getMonth()}`);
    }

    return DateTimeUtils.formatDateToString(
      input,
      this.getDateFormat(currentLang)
    );
  }

  private getDateFormat(selectedLang: LOCALIZATION_LOCALE): MONTH_FORMAT {
    switch (selectedLang) {
      case LOCALIZATION_LOCALE.VN:
        return MONTH_FORMAT.MONTH_FORMAT_VN;
      case LOCALIZATION_LOCALE.DE:
        return MONTH_FORMAT.MONTH_FORMAT_DE;
      case LOCALIZATION_LOCALE.US:
        return MONTH_FORMAT.MONTH_FORMAT_US;
      default:
        return MONTH_FORMAT.MONTH_FORMAT_US;
    }
  }
}
